'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DRGSpecialtyService = function () {
  function DRGSpecialtyService($http, $rootScope) {
    _classCallCheck(this, DRGSpecialtyService);

    if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  _createClass(DRGSpecialtyService, [{
    key: 'getSpecialties',
    value: function getSpecialties() {
      return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.refcode/queryall?domain=SPECIAL');
    }
  }, {
    key: 'putSpecialty',
    value: function putSpecialty(specialtyId, data) {
      return this.$http.put(WEBSERVICEURL + '/dataagility/api/service.refcode/' + specialtyId + '/', data);
    }
  }, {
    key: 'postSpecialty',
    value: function postSpecialty(data) {
      return this.$http.post(WEBSERVICEURL + '/dataagility/api/service.refcode/', data);
    }
  }]);

  return DRGSpecialtyService;
}();

var SpecialtiesController = function SpecialtiesController($http, $scope, LxDialogService, User, Constants, CONST, $rootScope, $sanitize, FunctionService) {
  _classCallCheck(this, SpecialtiesController);

  $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
  this.specialtyString = '';
  this.user = User.getUser();
  this.options = {
    removeChromeAutoComplete: true
  };

  this.form = "specialties";

  this.coderOptions = [];
  this.coder = {
    selectedCoder: null
  };

  this.specialty = {
    selectedSpecialty: []
  };

  this.roles = {
    selectedRole: undefined
  };
  this.roles.rolesOptions = CONST.ROLE;

  this.model = {};

  $scope.vm.isSubmitting = false;

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
  });

  // I think this is an unnecessary second call for Queries, which is never used.
  // But I don't have the guts to totally delete it - Henry Barnett 01/03/2023.
  /*
  Constants.getDivisionAndSpecialtyData().then(
       function successCallback(response) {
           $scope.vm.specialtyOptions = response.specialties;
       }
   );
  */

  this.fetchSpecialities = function (refCodeToSet) {
    new DRGSpecialtyService($http, $scope).getSpecialties().then(function successCallback(response) {
      $scope.vm.coderOptions = [];
      angular.forEach(response.data, function (value, key) {
        value.groupName = $sanitize(value.groupName);
        value.description = $sanitize(value.description).replace(/&amp;/g, "&");
        $scope.vm.coderOptions.push(value);
      });
      var indexOfItem = 0;
      if (refCodeToSet) {
        indexOfItem = $scope.vm.coderOptions.map(function (e) {
          return e.refCodeId;
        }).indexOf(refCodeToSet);
      }
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[indexOfItem];
    }, function errorCallback(response) {
      if (response.status === 401) {
        window.location.replace(window.location.origin + "/login?logout=true");
      }
    });
  };

  $scope.vm.fetchSpecialities(false);

  this.addSpecialty = addSpecialty;
  this.coderCallback = coderCallback;
  this.selectCallback = selectCallback;

  function addSpecialty() {

    // add a new blank user to the model
    var addNew = $scope.vm.coderOptions.push({});
    $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[addNew - 1];
  }

  function coderCallback(_newValue, _oldValue) {

    if ($scope.vm.coder.selectedCoder !== $scope.vm.model) angular.copy($scope.vm.coder.selectedCoder, $scope.vm.model);

    var spec,
        specialtyArr = $scope.vm.coder.selectedCoder.specialty;

    if (specialtyArr) {

      spec = specialtyArr.split(',');
    } else {

      spec = [];
    }

    $scope.vm.specialty.selectedSpecialty = [];

    angular.forEach(spec, function (value, key) {
      $scope.vm.specialty.selectedSpecialty.push(value);
    });

    // reset listener and form state
    // $scope.vm.form.$setPristine();
    $scope.vm.form.$setValidity();
    $scope.vm.form.$setUntouched();
  }

  function selectCallback(_newValue, _oldValue) {
    if ($scope.vm.model.specialty !== $scope.vm.specialty.selectedSpecialty.join() || $scope.vm.model.dtype !== $scope.vm.roles.selectedRole) $scope.vm.form.$setDirty();
  }

  this.openDialog = function () {
    LxDialogService.open("doubleCheck");
  };

  this.isButtonDisabled = function () {
    // dis/enable submit button

    if ($scope.vm.form.$pristine) {
      return true;
    } else {
      if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
        return $scope.vm.isSubmitting;
      } else {
        return true;
      }
    }
  };

  this.submitSpecialty = function () {
    // add selects data
    if ($scope.vm.model.refCodeId) {
      // existing user = put
      $scope.putData($scope.vm.model);
    } else {
      // new user = post
      $scope.vm.model.domain = 'SPECIAL';
      $scope.vm.model.hospitalId = CONST.HOSPITALID;
      $scope.vm.model.modifiedBy = $scope.vm.user.name;
      $scope.vm.model.createdBy = $scope.vm.user.name;
      $scope.vm.model.active = $scope.vm.model.active ? true : false;

      $scope.postData($scope.vm.model);
    }
  };

  $scope.putData = function (data) {
    $scope.vm.isSubmitting = true;
    var userId = data.refCodeId,
        data = JSON.stringify(data);

    new DRGSpecialtyService($http).putSpecialty(userId, data).then(function successCallback(response) {
      $scope.vm.coder.selectedCoder = $scope.vm.model;
      $scope.snackBar('Specialty updated');

      // Update the model in the coder options list
      for (var i = 0; i < $scope.vm.coderOptions.length; i++) {
        if ($scope.vm.coderOptions[i].refCodeId === $scope.vm.coder.selectedCoder.refCodeId) {
          $scope.vm.coderOptions[i].comments = $scope.vm.coder.selectedCoder.comments;
          $scope.vm.coderOptions[i].description = $scope.vm.coder.selectedCoder.description;
          $scope.vm.coderOptions[i].code = $scope.vm.coder.selectedCoder.code;
          $scope.vm.coderOptions[i].hl7 = $scope.vm.coder.selectedCoder.hl7;
          $scope.vm.coderOptions[i].active = $scope.vm.coder.selectedCoder.active;
        }
      }
      $scope.vm.form.$setPristine();
      $scope.vm.isSubmitting = false;
    }, function errorCallback(response) {
      $scope.snackBar("Database error, error saving User.");
      if (response.status === 401) {
        window.location.replace(window.location.origin + '/login?logout=true');
      }
      $scope.vm.isSubmitting = false;
    });
  };

  $scope.postData = function (data) {
    $scope.vm.isSubmitting = true;
    new DRGSpecialtyService($http).postSpecialty(data).then(function successCallback(response) {
      var parsedResponse = JSON.parse(response.data.context.entity).data;
      // add the ID, so it can be deleted if required
      $scope.vm.fetchSpecialities(parsedResponse.refCodeId);
      $scope.snackBar($scope.vm.specialtyString.charAt(0) + $scope.vm.specialtyString.substr(1).toLowerCase() + ' added');
      $scope.vm.form.$setPristine();
      $scope.vm.isSubmitting = false;
    }, function errorCallback(response) {
      $scope.snackBar('Database error, or ' + $scope.vm.specialtyString.toLowerCase() + ' already exists.');
      if (response.status === 401) {
        window.location.replace(window.location.origin + '/login?logout=true');
      }
      $scope.vm.isSubmitting = false;
    });
  };

  $scope.snackBar = function (message) {

    // upgrade MDI components
    window.componentHandler.upgradeAllRegistered();

    var snackbarContainer = document.querySelector('#specialty__notification');

    var data = {
      message: message,
      timeout: 2000,
      actionHandler: $scope.finaliseCheck,
      actionText: 'test'
    };

    snackbarContainer.MaterialSnackbar.showSnackbar(data);
  };

  this.fields = [{
    type: 'lx-input',
    key: 'description',
    templateOptions: {
      'label': 'Description',
      required: true
    }
  }, {
    type: 'lx-input',
    key: 'code',
    templateOptions: {
      'label': 'Code',
      required: true
    }
  }, {
    type: 'lx-input',
    key: 'hl7',
    templateOptions: {
      'label': 'HL7',
      required: true
    }
  }, {
    type: 'lx-switch',
    key: 'active',
    templateOptions: {
      'label': 'Active'
    }
  }, {
    type: 'lx-input',
    key: 'comments',
    templateOptions: {
      'label': 'Alert / Note',
      required: false
    }
  }];
};

exports.default = SpecialtiesController;


// WEBPACK FOOTER //
// ./client/app/common/admin/specialties/specialties.controller.js